var map = {
	"./chart-line.svg": "cHI2",
	"./chart.svg": "BxnT",
	"./chevron.svg": "uOiq",
	"./cloud.svg": "b//r",
	"./customers/algolia.svg": "fm3v",
	"./customers/angular.svg": "rMgc",
	"./customers/envato.svg": "WPwm",
	"./customers/microsoft.svg": "xD7L",
	"./customers/stackoverflow.svg": "G1Gk",
	"./device/device_laptop.svg": "X0jr",
	"./device/device_phone.svg": "a+wE",
	"./device/device_tablet.svg": "Obqr",
	"./device/laptop.svg": "jXRf",
	"./device/phone.svg": "NAG1",
	"./device/tablet.svg": "aW/z",
	"./features/chats.svg": "Ccs4",
	"./features/files.svg": "rELc",
	"./features/overview.svg": "uyk4",
	"./features/save.svg": "a4Y4",
	"./logo.svg": "0Naj",
	"./long-arrow-l.svg": "EjJv",
	"./long-arrow-r.svg": "sD9+",
	"./social/facebook.svg": "8dUo",
	"./social/medium.svg": "omBS",
	"./social/telegram.svg": "h9PM",
	"./social/twitter.svg": "PW4t",
	"./triangle.svg": "q0YH",
	"./users.svg": "tOSn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V7Hs";